<script setup>
import DefaultButton from '@/components/global-themed/buttons/DefaultButton.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import moment from 'moment';

const props = defineProps({
  websitesWithPublishedChanges: {
    type: Array,
    default: () => [],
  },
  terminateAt: {
    type: String,
    required: true,
  },
});

const store = useStore();

const websites = computed(() => props.websitesWithPublishedChanges);

const terminateAtDate = computed(() => moment(props.terminateAt).format('Do MMM YYYY'));
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container tw-rounded-xl tw-bg-white tw-p-8 tw-text-base tw-flex tw-gap-10 tw-flex-col">
    <div class="tw-flex tw-flex-col tw-gap-5">
      <div class="tw-flex tw-flex-col tw-gap-3">
        <div class="tw-font-bold tw-text-lg">
          Your plan has been successfully cancelled
        </div>

        <div>
          Your account will still be accessible until the end of your current billing period: {{ terminateAtDate }}.
        </div>
      </div>

      <div
        v-if="websites.length > 0"
        class="tw-flex tw-flex-col tw-gap-3"
      >
        <div class="tw-font-bold tw-text-lg">
          Download your Onsite Optimizer changes
        </div>

        <div>
          Below you'll find websites with the Onsite Optimizer script still present. We recommend downloading a CSV of all SEO adjustments made to each site.
        </div>

        <div
          v-for="website in websites"
          :key="website.id"
          class="tw-ml-4 tw-flex tw-gap-3"
        >
          <span>{{ website.url }}</span>
          <span>({{ website.count }} Published {{ website.count === 1 ? 'change' : 'changes' }})</span>
          <a
            v-if="website.count > 0"
            class="tw-underline tw-cursor-pointer"
            @click.prevent="store.dispatch('onsiteEditor/fetchChangesCsv', website.id)"
          >Download CSV</a>
        </div>
      </div>
    </div>

    <div class="tw-flex tw-justify-end">
      <DefaultButton
        as="a"
        href="/dash"
      >
        Return to Dashboard
      </DefaultButton>
    </div>
  </div>
</template>
